// extracted by mini-css-extract-plugin
module.exports = {"container":"Index_container__39eTv","intro":"Index_intro__1Dex9"};